import { EntitiesEngine } from './entities_engine';

export abstract class AbstractSystem {
  public readonly engine: EntitiesEngine;

  private _updateOrder: number = 0;

  protected constructor(engine: EntitiesEngine) {
    this.engine = engine;
  }

  public get updateOrder(): number {
    return this._updateOrder;
  }

  public set updateOrder(value: number) {
    this._updateOrder = value;
    this.engine.systems.invalidateOrder();
  }

  public register(): void {
    this.engine.systems.add(this);
  }

  public unregister(): void {
    this.engine.systems.remove(this);
  }

  public update(dt: number): void {
    this.updateImpl(dt);
  }

  protected abstract updateImpl(dt: number): void;
}
